// extracted by mini-css-extract-plugin
export default {"imgdiv":"_0f8514413a _5ba07b8190","img":"aaa9cbf528 b7295850ba"};